import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
	esp: (
		`
		<h4 class="mb-3 bold text-center">Aŭskultu vi…</h4>

		<div class="poem">
			<p class="poem-block mb-3">
				Aŭskultu vi! <br/>
				Se oni stelojn lumigas <br/>
				<span class="vm_step1">Do – estas ja bezonate al iu? <br/></span>
				Do – iu deziras, ke ili ekzistu? <br/>
				Do – iu nomigas ĉi tiujn kraĉetojn <br/>
				<span class="vm_step5">«la perlo»? <br/></span>

				Kaj sin superstreĉante <br/>
				<span class="vm_step2">en blizardoj de polvo tagmeza <br/></span>
				<span class="vm_step3">strebas aroge al Dio, <br/></span>
				<span class="vm_step4">timas, ke malfruiĝis, <br/></span>
				
				ploras, <br/>
				<span class="vm_step1">kisas lian muskolecan manon, <br/></span>
				
				petas – <br/>
				<span class="vm_step1">- ke nepre tuj ekestu la stelo! – <br/></span>
				
				ĵuras – <br/>
				<span class="vm_step1">ne plu elteni tiun senstelan suferon! <br/></span>
				
				Kaj poste <br/>
				<span class="vm_step1">maltrankviliĝas, <br/></span>
				<span class="vm_step2">sed imitas trankvilon, <br/></span>
				
				dirante al iu: <br/>
				«Nu do, ĉu jam vi ne plu tristas? <br/>
				<span class="vm_step2">Ne timas? <br/></span>
				<span class="vm_step3">Ĉu?!!» <br/></span>
				
				Aŭskultu vi! <br/>
				Se oni stelojn lumigas, <br/>
				<span class="vm_step1">Do – estas ja bezonate al iu? <br/></span>
				Do – estas vivonecese, <br/>
				<span class="vm_step1">ke dum ĉiu vespero <br/></span>
				<span class="vm_step2">en nigra nokt’ <br/></span>
				<span class="vm_step3">eklumiĝu almenaŭ unu stel’?!</span>
			</p>
		</div>


		<h4 class="mt-5 mb-3 bold text-center">Oni nenion komprenas</h4>



		<div class="poem">
			<p class="poem-block mb-3">
				Al frizisto mi venis, <br/>
				diris, trankvila: <br/>
				«Kombi orelojn vi estu kompleza!» <br/>
				La frizist’ glathara tuj iĝis vila, <br/>
				la vizaĝ’ eksimilis al piro peza. <br/>
				«Nenormala! <br/>
				<span class="vm_step2">Ruĝhara!» – <br/></span>
				<span class="vm_step4">- la vortoj kiel frap’. <br/></span>
				Insultoj sin ĵetis de kvik’ ĝis kviko. <br/>
				Kaj lo-o-o-o-nge <br/>
				<span class="vm_step2">aroge ridaĉis ies kap’, <br/></span>
				el tumulto montrante sin, kvazaŭ olda brasiko.
			</p>
		</div>


		<h4 class="mt-5 mb-3 bold text-center">Ĉu vi ekpovos?</h4>


		<div class="poem">
			<p class="poem-block mb-3">
				Mi tuj elverŝis el la glaso <br/>
				La farbon al la map’ rutina. <br/>
				Mi montris sur la plet’ de graso <br/>
				Frenezon de la mar’ obstina. <br/>
				Sur skvamo de la fiŝo lada <br/>
				Am-vokon legis mi sen dub’. <br/>
				Sed vi <br/>
				<span class="vm_step1">en kanto <br/></span>
				<span class="vm_step2">serenada <br/></span>
				ĉu ludos fluton <br/>
				<span class="vm_step2">de pluvtub’?</span>
			</p>
		</div>
	`
	)
}

const itemName = {
	esp: 'Vladimir Majakovskij'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;